'use client';

import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useHttp } from '@/shared/api/provider';
import { classNames } from '@/shared/lib/classnames/classnames';
import { formatMoney } from '@/shared/lib/string/formatMoney';
import { MedcenterBookingButtons } from './MedcenterBookingButtons';
import type { IMedcenterDetails, IMedcenterService } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenterDetails;
  hasPhones: boolean;
}

// @todo: убрать use client подумав как переписать, чтобы сеошился компонент.
export const MedcenterAppointment: React.FC<Props> = ({
  medcenter,
  hasPhones
}) => {
  const t = useTranslations();
  const {
    alias
  } = medcenter;
  const repositories = useHttp();
  const [services, setServices] = useState<IMedcenterService[]>([]);
  const [referredServiceId, setReferredServiceId] = useState<string | null>(null);
  useEffect(() => {
    const extractServiceIdFromReferrer = () => {
      if (typeof window === 'undefined') return null;
      try {
        const referrer = document.referrer;
        if (!referrer) return null;
        const url = new URL(referrer);
        const pathParts = url.pathname.split('/');
        if (pathParts.includes('services')) {
          const servicePart = pathParts.find(part => /^\d+/.test(part));
          if (servicePart) {
            const match = servicePart.match(/^(\d+)/);
            return match ? match[1] : null;
          }
        }
      } catch (error) {
        console.error('Error parsing referrer:', error);
      }
      return null;
    };
    const serviceId = extractServiceIdFromReferrer();
    setReferredServiceId(serviceId);
  }, []);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await repositories.medcenter.getMedcenterServiceByAlias(alias, 1);
        let filteredServices: IMedcenterService[] = [];
        if (referredServiceId) {
          const foundService = response.data.find(service => service.alias.startsWith(referredServiceId + '-'));
          if (foundService) {
            filteredServices = [foundService];
          }
        }
        if (filteredServices.length === 0) {
          filteredServices = response.data.filter(service => service.price !== null && service.price !== undefined).sort((a, b) => (a.price || 0) - (b.price || 0)).slice(0, 3);
        }
        setServices(filteredServices);
      } catch (error) {
        console.error('Error fetching medcenter services:', error);
      }
    };
    fetchServices();
  }, [alias, referredServiceId]);
  return <div className="my-2 h-fit rounded-2xl bg-bgPrimary p-4 md:mt-0" data-sentry-component="MedcenterAppointment" data-sentry-source-file="MedcenterAppointment.tsx">
      {services.length > 0 && <>
          <p className="mb-1">{t('medcenter.price.title')}</p>
          <div className="mb-4">
            {services.map(service => <div key={service.alias} className="flex items-center justify-between border-b py-2 last:border-b-0">
                <span className="hyphens-auto text-sm text-gray-700">{service.name}</span>
                <span className={classNames(`ml-4 flex-none text-base`, {
            'font-bold': !!service.price
          })}>
                  {['number', 'string'].includes(typeof service.price) ? formatMoney(service.price) + ' ₸' : t('doctor.price.no_price')}
                </span>
              </div>)}
          </div>
        </>}
      <MedcenterBookingButtons medcenter={medcenter} hasPhones={hasPhones} data-sentry-element="MedcenterBookingButtons" data-sentry-source-file="MedcenterAppointment.tsx" />
    </div>;
};